import {ModalAjax} from 'asteq.modalajax';

export class ModalAjaxManager {
    static instance = null;
    static modalTemplate = null;

    constructor(options = {}) {
        this.modalsStack = [];

        this.modalTemplate = null;
    }

    getLastModal() {
        if (!this.modalsStack || !this.modalsStack.length) {
            return null;
        }

        return this.modalsStack[this.modalsStack.length - 1];
    }

    getDisplayedModal() {
        const modal = this.getLastModal();
        return modal.isOpen() ? modal : null;
    }

    async loadAndShow(url, options = {}) {
        let modal = this.getLastModal();

        if (!modal) {
            const modalTemplate = this.constructor.getModalTemplate()?.cloneNode(true);

            modal = new ModalAjax({
                element: modalTemplate,
            });

            if (modal) {
                this.modalsStack.push(modal);
            }
        }

        if (!modal) {
            console.error('Не удалось получить объект модального окна');
            return;
        }

        if (options.isImmediateInDocument) {
            modal.insertIntoDocument();
        }
        
        await modal.show(url, {
            addClass: options.addClass,
        });
    }

    static getModalTemplate() {
        if (this.modalTemplate) {
            return this.modalTemplate;
        }

        const tempalteEl = document.querySelector('[data-local-modal-template]');
        if (!tempalteEl) {
            return null;
        }

        this.modalTemplate = tempalteEl.content.firstElementChild;
        return this.modalTemplate;
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new this({});
        }

        return this.instance;
    }
}